import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Cashier from './Cashier';
import QRCodeAuth from './QRCodeAuth';
import PaymentComplete from './PaymentComplete';
import PaymentFailure from './PaymentFailure';
import PaymentProcessing from './PaymentProcessing';

const PaymentFlow: React.FC = () => {
  return (
    <div className="page-container">
      <Routes>
        <Route path="/" element={<Navigate to="/payment/cashier" replace />} />
        <Route path="/cashier" element={<Cashier />} />
        <Route path="/qrcode" element={<QRCodeAuth />} />
        <Route path="/complete" element={<PaymentComplete />} />
        <Route path="/failure" element={<PaymentFailure />} />
        <Route path="/processing" element={<PaymentProcessing />} />
      </Routes>
    </div>
  );
};

export default PaymentFlow;